<template>
  <span class="restart-inner" aria-hidden="true">
    <Icon type="restart" :color="color" />
    <slot />
  </span>
</template>

<script>
import { color } from 'defaults';
import Icon from '../../icons';

export default {
  components: {
    Icon,
  },
  props: {
    color: {
      type: String,
      default: color,
    },
  },
};
</script>

<style lang="scss" scoped>
.restart-inner {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
